import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Logo = () => (
  <Link to="/" className="no-underline flex-shrink-0">
    <div className="logo flex items-center gap-1 max-w-[180px]">
      <div className="flex items-center relative flex-shrink-0">
        <img 
          src="/logo.png" 
          alt="Dialog Logo" 
          className="h-8 w-8 md:h-12 md:w-12 dark:block hidden object-contain"
        />
      </div>
      <div className="flex flex-col">
        <span className="text-lg md:text-2xl font-bold bg-gradient-to-r from-[#9F44F2] via-[#E852FF] to-[#FF56A5] bg-clip-text text-transparent whitespace-nowrap">
          Lifelike Agents
        </span>
        <span className="text-[8px] md:text-xs text-zinc-400 tracking-wider whitespace-nowrap">The Future of AI Conversations</span>
      </div>
    </div>
  </Link>
);

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Prevent ResizeObserver error
    const handleError = (error) => {
      if (error.message.includes('ResizeObserver')) {
        const resizeObserverError = error;
        window.requestAnimationFrame(() => {
          if (!resizeObserverError.cancelled) {
            throw error;
          }
        });
        return true;
      }
      return false;
    };

    window.addEventListener('error', handleError);
    
    // Cleanup
    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [window.location.pathname]);

  return (
    <nav className="nav-header h-12 md:h-16">
      <div className="nav-container h-full">
        <div className="flex items-center justify-between w-full h-full">
          <Logo />
          <div className="flex items-center gap-2">
            <div className="nav-links hidden md:flex items-center gap-6">
              <Link to="/solutions">Solutions</Link>
              <Link to="/use-cases">Use Cases</Link>
              <Link to="/features">Features</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/about">About</Link>
              <Link 
                to="/request-demo"
                className="book-demo-btn"
              >
                Book A Demo
              </Link>
              <Link 
                to="/login"
                className="text-white/80 hover:text-white transition-colors px-4 py-2 rounded-full border border-white/10 hover:border-white/20 backdrop-blur-sm"
              >
                Login
              </Link>
            </div>
            <button 
              className="md:hidden p-1.5 text-white hover:text-purple-400 transition-colors rounded-md bg-black/20 backdrop-blur-md border border-white/10"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div 
          className={`fixed inset-x-0 top-0 z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
            isMobileMenuOpen ? 'translate-y-0' : '-translate-y-full'
          }`}
        >
          <div className="bg-black/90 backdrop-blur-md shadow-lg">
            <div className="p-4">
              <div className="flex items-center justify-between mb-6">
                <Logo />
                <button 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="p-1.5 text-white hover:text-purple-400 transition-colors rounded-md bg-black/20 backdrop-blur-md border border-white/10"
                  aria-label="Close menu"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="grid gap-4">
                <Link 
                  to="/solutions" 
                  className="mobile-menu-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Solutions
                </Link>
                <Link 
                  to="/use-cases" 
                  className="mobile-menu-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Use Cases
                </Link>
                <Link 
                  to="/features" 
                  className="mobile-menu-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Features
                </Link>
                <Link 
                  to="/blog" 
                  className="mobile-menu-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Blog
                </Link>
                <Link 
                  to="/about" 
                  className="mobile-menu-link"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  About
                </Link>
                <Link 
                  to="/request-demo"
                  className="mobile-demo-btn"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Book A Demo
                </Link>
                <Link 
                  to="/login"
                  className="text-center text-white/80 hover:text-white transition-colors px-4 py-3 rounded-full border border-white/10 hover:border-white/20 backdrop-blur-sm"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Backdrop */}
        {isMobileMenuOpen && (
          <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 md:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}
      </div>
    </nav>
  );
};

export default Navigation; 